module.exports = __webpack_public_path__ + "static/media/14UNEP2.54603e52.jpg";